var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevatedTriglycerides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1275 8.21234C18.1275 6.38234 16.6475 4.90234 14.8175 4.90234C13.1175 4.90234 11.7375 6.18234 11.5475 7.83234C10.7875 7.49234 9.9475 7.30235 9.0575 7.30235C5.6775 7.30235 2.9375 10.0423 2.9375 13.4223C2.9375 16.8023 5.6775 19.5423 9.0575 19.5423C12.4375 19.5423 15.1775 16.8023 15.1775 13.4223C15.1775 12.7623 15.0675 12.1223 14.8775 11.5223C16.6775 11.4923 18.1375 10.0223 18.1375 8.21234H18.1275Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 7.02246C15.5077 7.02246 16.0376 7.55246 16.0376 8.21246",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6273 20.9323C19.9693 20.9323 21.0573 19.8443 21.0573 18.5023C21.0573 17.1602 19.9693 16.0723 18.6273 16.0723C17.2852 16.0723 16.1973 17.1602 16.1973 18.5023C16.1973 19.8443 17.2852 20.9323 18.6273 20.9323Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.627 17.9619C18.927 17.9619 19.1669 18.2019 19.1669 18.5019",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54774 5.52222C4.1663 5.52222 4.66774 5.02079 4.66774 4.40223C4.66774 3.78367 4.1663 3.28223 3.54774 3.28223C2.92919 3.28223 2.42773 3.78367 2.42773 4.40223C2.42773 5.02079 2.92919 5.52222 3.54774 5.52222Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29688 20.8125C3.57302 20.8125 3.79688 20.5886 3.79688 20.3125C3.79688 20.0364 3.57302 19.8125 3.29688 19.8125C3.02073 19.8125 2.79688 20.0364 2.79688 20.3125C2.79688 20.5886 3.02073 20.8125 3.29688 20.8125Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41757 18.382C2.50041 18.382 2.56757 18.3149 2.56757 18.232C2.56757 18.1492 2.50041 18.082 2.41757 18.082C2.33473 18.082 2.26758 18.1492 2.26758 18.232C2.26758 18.3149 2.33473 18.382 2.41757 18.382Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1571 4.02222C19.3615 4.02222 19.5271 3.85657 19.5271 3.65223C19.5271 3.44788 19.3615 3.28223 19.1571 3.28223C18.9528 3.28223 18.7871 3.44788 18.7871 3.65223C18.7871 3.85657 18.9528 4.02222 19.1571 4.02222Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99805 9.72266C11.068 9.72266 12.748 11.4027 12.748 13.4727",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5273 13.9727C17.6654 13.9727 17.7773 13.8607 17.7773 13.7227C17.7773 13.5846 17.6654 13.4727 17.5273 13.4727C17.3893 13.4727 17.2773 13.5846 17.2773 13.7227C17.2773 13.8607 17.3893 13.9727 17.5273 13.9727Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1582 12.3418C19.4343 12.3418 19.6582 12.1179 19.6582 11.8418C19.6582 11.5657 19.4343 11.3418 19.1582 11.3418C18.8821 11.3418 18.6582 11.5657 18.6582 11.8418C18.6582 12.1179 18.8821 12.3418 19.1582 12.3418Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51672 5.16234C9.72659 5.16234 9.89671 4.99221 9.89671 4.78234C9.89671 4.57247 9.72659 4.40234 9.51672 4.40234C9.30686 4.40234 9.13672 4.57247 9.13672 4.78234C9.13672 4.99221 9.30686 5.16234 9.51672 5.16234Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatedTriglycerides);
export default __webpack_public_path__ + "static/media/ElevatedTriglycerides.9d8ef2b020cb3a3974751c9586e12776.svg";
export { ForwardRef as ReactComponent };